var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row justify-content-center" }, [
    _vm.requested
      ? _c(
          "div",
          { staticClass: "col justify-content-center text-center mb-3" },
          [
            _c("h5", { staticClass: "text-white mt-5" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("message.requestSucceeded")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c("h6", { staticClass: "text-white" }, [
              _vm._v(
                "\n            " +
                  _vm._s(`${_vm.$t("message.restoreLetterSent")}: `)
              ),
              _c("strong", [_vm._v(_vm._s(_vm.mail))]),
            ]),
          ]
        )
      : _c(
          "div",
          {
            staticClass: "form-container d-flex flex-column align-items-center",
          },
          [
            _c("div", { staticClass: "card bg-transparent border-0" }, [
              _c(
                "div",
                { staticClass: "card-body" },
                [
                  _c("h2", { staticClass: "title-text mx-auto mb-3" }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("title.passwordRecovery")) +
                        "\n                "
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "ValidationObserver",
                    { ref: "observer" },
                    [
                      _c("v-input", {
                        staticClass: "input-w-default mb-0 mt-2",
                        attrs: {
                          type: "text",
                          debounce: 500,
                          placeholder: _vm.$t("placeholder.email"),
                          icon: _vm.$getInputIcon(_vm.mail, "email"),
                          rules: "required|email|emailExists",
                        },
                        on: { keyEnterUp: _vm.restore },
                        model: {
                          value: _vm.mail,
                          callback: function ($$v) {
                            _vm.mail = $$v
                          },
                          expression: "mail",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "restore-button w-75 mb-2",
                      on: { click: _vm.restore },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("button.restore")) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }